import { DATASOURCE_FREE_BUSY } from "@/utils/constants.js";
import i18n from "@/plugins/i18n";
import { mapGetters } from "vuex";
import moment from "moment";
import CommonUtils from "@/utils/common-utils";
import EmailUtils from "@/utils/email-utils";
import CONFIG from "@/config/config";
import CryptoJS from "crypto-js";
import BaseService from "@/shared/services/BaseService";

export default {
    name: "SecureMailUtils",
    mixins: [CommonUtils, EmailUtils],
    data() {
        return {
            // form dữ liệu tìm kiêm bên trái
            formMenuLeft: {
                listCalFolderIds: [],
                tagName: ""
            },
            //data
            CONFIG_AVATAR: "CONFIG_AVATAR",
            IV: CryptoJS.enc.Utf8.parse('1982576EF73DA76C'),
            // ALGO: { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
            ALGO: BaseService.ALGO,
            secretKey: CONFIG["secureSecretKey" || "mail@se*vtt$2025"]
        };
    },
    computed: {
        ...mapGetters([
            "treeCalendarFolder",
            "preference",
            "emailAddress",
            "timeZoneCurrent"
        ]),
        datasourceCalendarFolder() {
            return this.getListCalendarFolder(this.treeCalendarFolder);
        }
    },
    methods: {
        getFreeBusyWithValue(fb) {
            const _type = DATASOURCE_FREE_BUSY.find(e => e.value == fb);
            return _type ? _type : {};
        },
        getColorFreeBusy(fb) {
            const _type = DATASOURCE_FREE_BUSY.find(e => e.value == fb);
            return _type ? _type.color : "";
        },
        getHexaToRgba(hex, opacityRate) {
            const rgb = this.hexToRgb(hex);
            return `rgba(${rgb.toString()},${opacityRate})`;
        },
        getNameFreeBusy(fb) {
            const _type = DATASOURCE_FREE_BUSY.find(e => e.value == fb);
            return _type ? _type.label : "";
        },

        getUrlFileContentSecureService(attachIdEncrypt) {
            if (!attachIdEncrypt) return null;
            return `${this.$configZimbra.ENDPOINT.secureMailImg}/load-attach?attachIdEncrypt=${attachIdEncrypt}&userKey=${this.encryptForBE(this.getEmailLogin(), this.secretKey)}&xKeyToken=${this.encryptForBE(moment().format("YYYYMMDDHHmmss"), this.secretKey)}`;
            // return `${this.$configZimbra.ENDPOINT.secureMailService}/v1/attach/load-attach?attachIdEncrypt=${attachIdEncrypt}`;
        },
        getEmailLogin() {
            let { username } = this.getLocalStorageObject("zimbra_token");
            return username ? username : null;
        },

        encryptForBE(plainText, secretKey) {
            if (!secretKey) {
                throw new Error("secretKey phải dài đúng 16 ký tự (AES-128).");
            }
            const key = CryptoJS.enc.Utf8.parse(secretKey);
            const data = CryptoJS.enc.Utf8.parse(plainText);

            const encrypted = CryptoJS.AES.encrypt(data, key, { iv: this.IV, ...this.ALGO });
            const b64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
            // Java dùng URLEncoder.encode(..., UTF-8)
            return encodeURIComponent(b64);
        },
        getHtmlSecureMail(modalSecure, dataMail, mailCode, contentTempMail) {
            const title = dataMail?.su ?? "";
            const dateExpiredText = moment(modalSecure?.dateExpired)?.local()?.format("DD/MM/YYYY HH:mm");
            const hrefSecureMail = `${this.$configZimbra["CLIENT_ADDRESS"]}/secure-mail?mailId=${mailCode}`;
            const emailFrom = Array.isArray(dataMail?.e) ? dataMail?.e?.find((item) => item?.t === "f")?.a : "";
            return `
            <html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en">

<head>
    <title></title>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <!--[if mso]>
    <xml>
        <w:WordDocument xmlns:w="urn:schemas-microsoft-com:office:word">
            <w:DontUseAdvancedTypographyReadingMail />
        </w:WordDocument>
        <o:OfficeDocumentSettings>
            <o:PixelsPerInch>96</o:PixelsPerInch>
            <o:AllowPNG />
        </o:OfficeDocumentSettings>
    </xml>
    <![endif]--><!--[if !mso]><!--><!--<![endif]-->
    <style>
        * {
            box-sizing: border-box;
            font-family: 'Inter';
        }

        body {
            margin: 0;
            padding: 0;
        }

        a[x-apple-data-detectors] {
            color: inherit !important;
            text-decoration: inherit !important;
        }

        #MessageViewBody a {
            color: inherit;
            text-decoration: none;
        }

        p {
            line-height: inherit
        }

        .desktop_hide,
        .desktop_hide table {
            mso-hide: all;
            display: none;
            max-height: 0px;
            overflow: hidden;
        }

        .image_block img + div {
            display: none;
        }

        sup,
        sub {
            font-size: 75%;
            line-height: 0;
        }
        span.object span {
            color: #2a85ff !important;
        }

        @media (max-width: 620px) {
            .image_block div.fullWidth {
                max-width: 100% !important;
            }

            .mobile_hide {
                display: none;
            }

            .row-content {
                width: 100% !important;
            }

            .stack .column {
                width: 100%;
                display: block;
            }

            .mobile_hide {
                min-height: 0;
                max-height: 0;
                max-width: 0;
                overflow: hidden;
                font-size: 0px;
            }

            .desktop_hide,
            .desktop_hide table {
                display: table !important;
                max-height: none !important;
            }
        }
        html, body { width:100%; max-width:100%; overflow-x:hidden; }

        /*!* Đừng dùng inline-table vì nó shrink-wrap *!*/
        /*table[style*="display: inline-table"] { display: table !important; }*/

        /*!* Tất cả table khung ngoài phải full width *!*/
        /*.nl-container,*/
        /*.nl-container > tbody > tr > td > table,*/
        /*.nl-container table[align="center"] {*/
        /*  width: 100% !important;*/
        /*  table-layout: fixed !important;*/
        /*}*/

        /*!* Các nơi đang set width: 80% hoặc 600px → full *!*/
        /*table[style*="width: 80%"] { width: 100% !important; }*/
        /*.row-content,*/
        /*table[style*="width: 600px"] { width: 100% !important; max-width: 600px; }*/

        /*!* Ảnh và nội dung không tràn *!*/
        /*img { max-width:100% !important; height:auto !important; display:block; }*/
        /*td, p { overflow-wrap:anywhere; word-break:break-word; }*/

        /* Mobile: giữ 100% theo iframe viewport */
        @media only screen and (max-width: 9999px) {
            .row-content { width:100% !important; max-width: 700px;}
        }
        @media (min-width: 1601px) {
            .table-wrap { width: 100vw !important; }
        }
    </style>
    <!--[if mso ]>
    <style>sup, sub {
        font-size: 100% !important;
    }

    sup {
        mso-text-raise: 10%
    }

    sub {
        mso-text-raise: -10%
    }</style> <![endif]-->
</head>

<body class="body"
      style="background-color: #FFFFFF; margin: 0; padding: 0; -webkit-text-size-adjust: none; text-size-adjust: none;">
<table class="nl-container table-wrap" border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%"
       style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #F7F8F9; display: inline-table !important; width: 100% !important;">
    <tbody>
    <tr>
        <td align="center">
            <table align="center" border="0" cellpadding="0" cellspacing="0"
                   style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; display: inline-block; margin: 0 auto;">
                <tr>
                    <td align="center">
                        <table background="cid:${contentTempMail.bg}" align="center" border="0" cellpadding="0"
                               cellspacing="0"
                               role="presentation"
                               style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; display: table !important;">
                            <tr>
                                <td align="center">
                                    <table class="row row-1" align="center" width="100%" border="0" cellpadding="0"
                                           cellspacing="0"
                                           role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                                        <tbody>
                                        <tr>
                                            <td class="pad" style="padding: 35px;width:100%;"></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <table class="row row-2" align="center" width="100%" border="0" cellpadding="0"
                                           cellspacing="0"
                                           role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; display: table;">
                                        <tbody>
                                        <tr>
                                            <td>
                                                <table class="row-content stack" align="center" border="0"
                                                       cellpadding="0"
                                                       cellspacing="0" role="presentation"
                                                       style="display: table; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #ffffff; background-position: center top; color: #000000; width: 600px; margin: 0 auto; border-radius: 8px; border: 0.66px solid #F7F8F9;">
                                                    <tbody>
                                                    <tr>
                                                        <td class="column column-1" width="100%"
                                                            style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top;">
                                                            <table class="image_block block-1" width="100%" border="0"
                                                                   cellpadding="0" cellspacing="0" role="presentation"
                                                                   style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; white-space:normal;">
                                                                <tr>
                                                                    <td style="padding: 24px; width: 100%">
                                                                        <table role="presentation" border="0"
                                                                               cellspacing="0"
                                                                               cellpadding="0" width="100%">
                                                                            <tr>
                                                                                <td width="40" valign="middle">
                                                                                    <div>
                                                                                        <img
                                                                                            src="cid:${contentTempMail?.icon}"
                                                                                            style="max-width: 100%;"
                                                                                            alt="Logo">
                                                                                    </div>
                                                                                </td>
                                                                                <td valign="middle"
                                                                                    style="padding-left:12px; font-size: 20px; font-weight: 500; line-height: 32px; color: #313131">
                                                                                    ${title}
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>

                                                                </tr>
                                                                <tr>
                                                                    <td class="pad" style="padding: 0 24px;width:100%;">
                                                                        <div class="alignment"
                                                                             style="border-radius: 8px">
                                                                            <p style="margin:0; line-height: 24px; color: #313131" class="a-templ-text-ct">
                                                                                <a href="mailto:${emailFrom}" style="color:#2A85FF !important; text-decoration:none;"><strong><span class="object" style="color:#2A85FF !important;">${emailFrom}</span></strong></a> đã gửi một <strong>thư bảo mật</strong>.
                                                                            </p>
                                                                            <p style="margin:0; line-height: 24px; color: #313131">
                                                                                Bạn có thể đọc thư này bằng cách nhấn vào nút bên dưới.
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td style="padding:16px 24px 0 24px; font-size:13px; color:#111827;">
                                                                        <div class="alignment">
                                                                            <!--[if mso]>
                                                                            <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                                                                                         xmlns:w="urn:schemas-microsoft-com:office:word"
                                                                                         href="${hrefSecureMail}"
                                                                                         style="height:32px; v-text-anchor:middle; width:150px;font-size:16px;"
                                                                                         arcsize="12%"
                                                                                         stroke="f"
                                                                                         fillcolor="#EE0033">
                                                                                <w:anchorlock/>
                                                                                <center style="color:#FFFFFF; font-family:Arial, sans-serif; font-size:14px; font-weight:700;">
                                                                                    Mở thư bảo mật
                                                                                </center>
                                                                            </v:roundrect>
                                                                            <![endif]-->

                                                                            <!--[if !mso]>&lt;!&ndash; -->
                                                                            <a href="${hrefSecureMail}"
                                                                               style="background:#E03;border-radius:8px;color:#FFFFFF;font-size:16px;font-weight:bold;text-decoration:none;display:inline-block;padding:6px 12px;line-height:20px;">
                                                                                Mở thư bảo mật
                                                                            </a>
                                                                            <!--<![endif]-->
                                                                        </div>
                                                                    </td>

                                                                </tr>
                                                                <tr>
                                                                    <td style="padding:24px; font-size:16px; font-style: normal; font-weight: 400; line-height: 24px; color:#313131;">
                                                                        <p style="margin:0; text-wrap: auto">
                                                                            Thư này có hiệu lực tới
                                                                            <strong>${dateExpiredText}</strong>.<br>
                                                                            Sau thời gian trên, thư sẽ bị khoá và bạn sẽ không thể mở thư.
                                                                        </p>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td style="padding:0 24px 24px 24px; font-size:16px; font-style: normal; font-weight: 400; line-height: 24px; color:#606060;">
                                                                        <p style="margin:0; white-space: normal; overflow-wrap: anywhere;">
                                                                            Thư bảo mật được sử dụng để gửi thông tin bảo mật qua vMail. Với thư bảo mật, người gửi có thể đặt thời gian hết hạn cho thư và người nhận cần xác thực để mở thư. Tìm hiểu thêm
                                                                            <a href="${CONFIG["ENDPOINT"]["secureMailGuideLink"] ?? "https://vmail.viettel.vn/user-guide/HDSD_MAILBAOMAT.pdf"}"
                                                                            style="color:#2A85FF; text-decoration: underline !important;">Tại đây</a>.
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </table>


                    </td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td align="center" valign="middle" style="padding:0;">
            <table role="presentation" border="0" cellpadding="0" cellspacing="0" align="center" style="display: inline-table !important;">
                <tr>
                    <td align="center" valign="middle"
                        style="text-align:center; vertical-align:middle; padding:24px 0;">
                        <div style="display:inline-block;">
                            <img src="cid:${contentTempMail.logo}" alt="Icon"
                                 style="max-width: max-content" />
                        </div>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td align="center">
            <div style="border-top: 0.66px solid #EFEFEF"></div>
        </td>
    </tr>
    <tr>
        <td align="center" valign="middle" style="padding:0;">
            <table role="presentation" border="0" cellpadding="0" cellspacing="0" align="center" style="display: inline-table !important;">
                <tr>
                    <td align="center" valign="middle"
                        style="text-align:center; vertical-align:middle; padding:24px 0 0 0;">
                        <div style="display:inline-block; color: #888888">
                            Phát triển bởi Trung tâm Công nghệ Thông tin
                        </div>
                    </td>
                </tr>
                <tr>
                    <td align="center" valign="middle"
                        style="text-align:center; vertical-align:middle; padding:0 0 0 24px;">
                        <div style="display:inline-block; color: #888888">
                           Bản quyền thuộc Tập đoàn Công nghiệp - Viễn thông Quân đội Viettel
                        </div>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    </tbody>
</table>
</body>

</html>

         `;
        }

    }
};
